import React, { useContext, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

import ActiveComponentContext from "../../../contexts/ActiveComponentContext";
import useOutputReportStore from "../../../store/OutputReport.store";
import { getOutputType } from "../../../utils/helpers/dataTable";

import PortfolioCharacteristicsDataTable from "./PortfolioCharacteristicsDataTable";

const getVisibleRows = ({ reportType, assetType }) => {
  if (assetType === "equity") {
    return [
      "Number of Securities[3]",
      "Tracking Error to Benchmark",
      "% of Market Value in Stocks",
      "Beta to Benchmark",
      "Dividend Yield",
      "Weight in Top Ten Holdings (%)",
      "Average Weighted Market Cap (Billions $)[4]",
      "Large Cap (%)[4]",
      "Mid Cap (%)[4]",
      "Small Cap (%)[4]",
      "Defensive Sectors (%)[4]",
      "Highly Cyclical Sectors (%)[4]",
      "Moderately Cyclical Sectors (%)[4]",
    ];
  }

  const esgRating = "ESG Rating";
  const endingTrackingError = "Ending Tracking Error";
  const additionalAssetKeys =
    assetType !== "muni"
      ? [
          "Option Adjusted Spread (OAS)",
          "Option Adjusted Spread Duration (OASD)",
          "Duration Times Spread (DTS)",
        ]
      : [];

  const additionalKeys = {
    cash: {
      corp: [esgRating],
      muni: [],
      treasury: [esgRating],
      tbill: [],
    },
    transition: {
      corp: [endingTrackingError, esgRating],
      muni: [endingTrackingError],
      treasury: [endingTrackingError],
    },
  };

  return [
    "Number of Securities",
    "Beta to Index",
    "Effective Duration (OAD)",
    "Time to Maturity",
    "Coupon",
    "Yield to Maturity [3]",
    "Yield to Worst [3]",
    "Credit Quality",
    "Price",
    "% Callable",
    "Coupon Income (Next 12 months) [4]",
    "Liquidity Score (LQA)",
    ...additionalKeys[reportType][assetType],
    ...additionalAssetKeys,
  ];
};

const PortfolioCharacteristicsReport = () => {
  const [visibleRows, setVisibleRows] = useState([]);
  const reportName = "Portfolio Characteristics";
  const data = useOutputReportStore((state) => state.data);
  const { active: activeId, setActive: setActiveComponent } = useContext(
    ActiveComponentContext
  );
  const { ref, entry } = useInView({
    /* Optional options */
    threshold: 0.25,
    trackVisibility: true,
    delay: 100,
  });

  useEffect(() => {
    if (entry?.isVisible && entry?.target?.id !== activeId) {
      setActiveComponent(entry.target.id);
    }
  }, [entry, setActiveComponent, activeId]);

  useEffect(() => {
    if (data) {
      const { reportType, assetType } = getOutputType(data);
      setVisibleRows(getVisibleRows({ reportType, assetType }));
    }
  }, [data]);

  if (!data?.[reportName]) {
    return null;
  }

  return (
    <article ref={ref} id="PortfolioCharacteristics" className="report-article">
      <header className="section-title report-article__header">
        <h1>{`Proposed ${reportName}`}</h1>
      </header>

      <div className="report-article__content">
        <section className="report-article__visual">
          <PortfolioCharacteristicsDataTable visibleRows={visibleRows} />
        </section>
      </div>
    </article>
  );
};

export default PortfolioCharacteristicsReport;
